"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = require("../styled");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _TextField = require("./TextField");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A Select component based on the brilliant [`react-select`](https://github.com/JedWatson/react-select) by Jed Watson.
 *
 * Most of the API is preserved, so for more detailed usage please refer to the [official documentation](https://react-select.com/home).
 *
 * The props here just expose our own API.
 *
 */
var Select = function Select(_ref) {
  var label = _ref.label,
      help = _ref.help,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$shrinked = _ref.shrinked,
      shrinked = _ref$shrinked === void 0 ? false : _ref$shrinked,
      style = _ref.style,
      className = _ref.className,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      options = _ref.options,
      menuPlacement = _ref.menuPlacement,
      rest = _objectWithoutProperties(_ref, ["label", "help", "value", "defaultValue", "shrinked", "style", "className", "onChange", "onBlur", "onFocus", "options", "menuPlacement"]);

  var theme = (0, _styled.useTheme)();
  var themeConfig = React.useCallback(function (original) {
    return _objectSpread(_objectSpread({}, original), {}, {
      colors: {
        primary: theme.primary,
        primary75: (0, _polished.transparentize)(0.25, theme.primary),
        primary50: (0, _polished.transparentize)(0.5, theme.primary),
        primary25: (0, _polished.transparentize)(0.75, theme.primary),
        danger: theme.danger,
        // We don't lighten it, since we need to work with multiple background colours
        // because of WLs.
        dangerLight: (0, _polished.transparentize)(0.25, theme.danger),
        neutral0: (0, _polished.mix)(0, theme.foreground, theme.background),
        neutral5: (0, _polished.mix)(0.05, theme.foreground, theme.background),
        neutral10: (0, _polished.mix)(0.1, theme.foreground, theme.background),
        neutral20: (0, _polished.mix)(0.2, theme.foreground, theme.background),
        neutral30: (0, _polished.mix)(0.3, theme.foreground, theme.background),
        neutral40: (0, _polished.mix)(0.4, theme.foreground, theme.background),
        neutral50: (0, _polished.mix)(0.5, theme.foreground, theme.background),
        neutral60: (0, _polished.mix)(0.6, theme.foreground, theme.background),
        neutral70: (0, _polished.mix)(0.7, theme.foreground, theme.background),
        neutral80: (0, _polished.mix)(0.8, theme.foreground, theme.background),
        neutral90: (0, _polished.mix)(0.9, theme.foreground, theme.background)
      }
    });
  }, [theme]);
  var styles = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        paddingTop: '0.2em'
      });
    },
    control: function control() {
      return {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        boxSizing: 'border-box'
      };
    }
  };

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var _React$useState3 = React.useState('0'),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      legendWidth = _React$useState4[0],
      setLegendWidth = _React$useState4[1];

  var _React$useState5 = React.useState(!!value),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      hasRenderableValue = _React$useState6[0],
      setHasRenderableValue = _React$useState6[1];

  var labelRef = React.useRef(null);
  var blurHandler = React.useCallback(function (e) {
    if (onBlur) onBlur(e);
    setFocused(false);
  }, [setFocused, onBlur]);
  var focusHandler = React.useCallback(function (e) {
    if (onFocus) onFocus(e);
    setFocused(true);
  }, [setFocused, onFocus]);
  var handleChange = React.useCallback(function (value, action) {
    if (onChange) onChange(value, action);
    setHasRenderableValue(!!value);
  }, // It says types O and M are required as deps
  // eslint-disable-next-line
  [onChange]);
  var shrink = !!(shrinked || hasRenderableValue || focused || defaultValue);
  React.useEffect(function () {
    if (label) {
      labelRef.current && setLegendWidth("calc(".concat(labelRef.current.offsetWidth * 0.75, "px + 0.5em)"));
    } else {
      setLegendWidth('0');
    }
  }, [label]);
  return /*#__PURE__*/React.createElement(_TextField.Container, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(_TextField.Wrapper, {
    hasLabel: !!label
  }, /*#__PURE__*/React.createElement(_TextField.Label, {
    focused: focused,
    hasValue: hasRenderableValue,
    shrinked: shrink,
    ref: labelRef
  }, label), /*#__PURE__*/React.createElement(_reactSelect["default"], _extends({}, rest, {
    onChange: handleChange,
    defaultValue: defaultValue,
    value: value,
    options: options,
    placeholder: null,
    onFocus: focusHandler,
    onBlur: blurHandler,
    styles: styles,
    theme: themeConfig,
    menuPlacement: menuPlacement
  })), /*#__PURE__*/React.createElement(_TextField.Fieldset, {
    focused: focused,
    style: {
      paddingLeft: shrink ? '0.6em' : "calc(".concat(legendWidth, " / 2)")
    },
    hasValue: hasRenderableValue
  }, /*#__PURE__*/React.createElement(_TextField.Legend, {
    style: {
      width: shrink ? legendWidth : 0
    }
  }, "\u200B"))), help != null && /*#__PURE__*/React.createElement(_TextField.Help, null, help));
};

var _default = Select;
exports["default"] = _default;